import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const BrandLogo = ({ className = '', size = 'md' })=>{
    const sizeClasses = {
        sm: 'w-4 h-4',
        md: 'w-5 h-5',
        lg: 'w-6 h-6'
    };
    return /*#__PURE__*/ _jsx("img", {
        src: "/images/favicon-edsense.ico",
        alt: "EduSense",
        className: `${sizeClasses[size]} ${className} object-contain rounded-lg border border-white/20`
    });
};
export default BrandLogo;
